import { SubmitGroupItemModel } from '@libs/form/models';

export const EmployeeDeleteSubmitGroupItem: SubmitGroupItemModel = {
  type: 'submit',
  items: [
    {
      name: 'delete',
      label: 'Mitarbeiter löschen',
      theme: 'filled',
    },
  ],
};

